import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import axios from 'axios';

const BASE_URL = 'https://moga-dev.com/api';

export const fetchNewProducts = createAsyncThunk(
  'products/fetchNewProducts',
  async ({ sortId, page }, { rejectWithValue }) => {
    try {
      const allProductsRes = await axios.get(`${BASE_URL}/products/news`);
      let products = allProductsRes.data.data || [];
      const totalCount = products.length;

      const sortedRes = await axios.get(`${BASE_URL}/products/${sortId}`);
      const sortedIds = sortedRes.data.data.map(p => p.id);

      products.sort(
        (a, b) => sortedIds.indexOf(a.id) - sortedIds.indexOf(b.id)
      );


      return {
        allProducts: products,
        topTen: products.slice(0, 10),
        totalCount,
        totalPages: 1,
      };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch new products');
    }
  }
);

const productNewsSlice = createSlice({
  name: 'newProducts',
  initialState: {
    allProducts: [],
    topTen: [],
    loading: false,
    error: null,
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
    itemsPerPage: 12,
    sortId: 'recent-to-old',
  },
  reducers: {
    setNewsPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setNewsSort: (state, action) => {
      state.sortId = action.payload;
      state.currentPage = 1;
    },
    increaseItemsPerPage: (state, action) => {
      const increment = action.payload || 12; // default +10
      state.itemsPerPage += increment;
    },
    decreaseItemsPerPage: (state, action) => {
      const decrement = action.payload || 12; // default -10
      state.itemsPerPage = Math.max(12, state.itemsPerPage - decrement); // Minimum 10
    },
    setItemsPerPage: (state, action) => {
      state.itemsPerPage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNewProducts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNewProducts.fulfilled, (state, action) => {
        const { allProducts, topTen, paginatedProducts, totalPages, totalCount } = action.payload;
        state.loading = false;
        state.allProducts = allProducts;
        state.topTen = topTen;
        state.paginatedProducts = paginatedProducts;
        state.totalPages = totalPages;
        state.totalCount = totalCount;
      })
      .addCase(fetchNewProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setNewsPage, setNewsSort , increaseItemsPerPage , decreaseItemsPerPage , setItemsPerPage } = productNewsSlice.actions;

export default productNewsSlice.reducer;
